import { InvoiceReportTemplateData } from "./InvoiceReportTemplateData";
import { Invoice } from "../models/Invoice";
import { headerInvoiceLogo } from "../constants/PdfReports";
import { formatDate, addThousandSeparator } from "../core/Utility";

export const InvoiceReportImportTemplate = (
  data: InvoiceReportTemplateData | any
) => {
  return {
    background: [],
    margin: [0, 0, 0, 30],
    header: [],
    footer: [
      {
        width: "50%",
        layout: "noBorders",
        margin: [30, 0, 30, 0],
        table: {
          widths: ["50%", "50%"],
          body: [
            [
              {
                text: `Dokument je važeći bez potpisa i pečata`,
                style: "textLeft",
              },
              {
                text: `Direktor`,
                style: "textRight",
              },
            ],
          ],
        },
      },
      {
        width: "50%",
        layout: "noBorders",
        table: {
          widths: ["50%", "50%"],
          body: [
            [
              {
                text: ``,
                style: "textLeft",
              },
              {
                text: `Miodrag Lazović`,
                style: "textRight",
                margin: [0, 0, 30, 0],
              },
            ],
          ],
        },
      },
    ],
    pageOrientation: "portrait",
    pageSize: "A4",
    content: [
      {
        width: "50%",
        layout: "noBorders",
        table: {
          widths: ["50%", "50%"],
          body: [
            [
              {
                image: headerInvoiceLogo,
                alignment: "left",
                margin: [10, 5, 0, 0],
              },
              {
                layout: "noBorders",
                table: {
                  widths: ["100%"],
                  body: [
                    [
                      {
                        text: `Globus travel`,
                        style: "textRight",
                      },
                    ],
                    [
                      {
                        text: `Svetog Serafima Sarovskog 2`,
                        style: "textRight",
                      },
                    ],
                    [
                      {
                        text: `11273 Beograd`,
                        style: "textRight",
                      },
                    ],
                    [
                      {
                        text: `Tel: (+381) 11 4026 452`,
                        style: "textRight",
                      },
                    ],
                    [
                      {
                        text: `Email: dusancakic@globustravel.co.rs`,
                        style: "textRight",
                      },
                    ],
                    [
                      {
                        text: `Web: www.globustravel.co.rs`,
                        style: "textRight",
                      },
                    ],
                    [
                      {
                        text: `Licenca: OTP 9/2022 Kat.A`,
                        style: "textRight",
                      },
                    ],
                    [
                      {
                        text: `Ž.R: 205-112964-17`,
                        style: "textRight",
                      },
                    ],
                    [
                      {
                        text: `PIB: 100270837`,
                        style: "textRight",
                      },
                    ],
                  ],
                },
              },
            ],
          ],
        },
      },
      {
        text: `Profaktura br: ${data?.reportData?.sequenceNumber}/${new Date(
          data.reportData.createdAt
        ).getFullYear()}`,
        style: "title",
      },
      {
        width: "50%",
        layout: "noBorders",
        table: {
          widths: ["65%", "35%"],
          body: [
            [
              {
                text: `Komitent: ${data.reportData.clientName}`,
                style: "textLeft",
              },
              {
                text: `Datum: ${formatDate(
                  new Date(data.reportData?.createdAt)
                )}`,
                style: "textRight",
              },
            ],
          ],
        },
      },
      {
        width: "50%",
        layout: "noBorders",
        table: {
          widths: ["65%", "35%"],
          body: [
            [
              {
                text: `Adresa: ${data.reportData?.address ?? ""}`,
                style: "textLeft",
              },
              {
                text: ``,
                style: "textRight",
              },
            ],
          ],
        },
      },
      {
        width: "50%",
        layout: "noBorders",
        table: {
          widths: ["65%", "35%"],
          body: [
            [
              {
                text: `${
                  data.reportData?.isCompany ? "Matični broj: " : "JMBG: "
                } ${
                  data.reportData?.isCompany
                    ? data.reportData?.companyId ?? ""
                    : data.reportData?.personalId ?? ""
                }`,
                style: "textLeft",
              },
              {
                text: ``,
                style: "textRight",
              },
            ],
          ],
        },
      },
      {
        width: "50%",
        layout: "noBorders",
        table: {
          widths: ["65%", "35%"],
          body: [
            [
              {
                text: `${
                  data.reportData?.isCompany ? "PIB: " : "BrLk/Pasoša: "
                } ${
                  data.reportData?.isCompany
                    ? data.reportData?.vatNumber ?? ""
                    : data.reportData?.nationalId ?? ""
                }`,
                style: "textLeft",
              },
              {
                text: ``,
                style: "textRight",
              },
            ],
          ],
        },
      },
      {
        canvas: [
          {
            lineColor: "gray",
            type: "line",
            x1: 0,
            y1: 0,
            x2: 515,
            y2: 0,
            lineWidth: 1,
          },
        ],
        margin: [0, 5, 0, 10],
      },
      {
        width: "50%",
        layout: "noBorders",
        table: {
          widths: ["20%", "13%", "13%", "20%", "13%", "8%", "13%"],
          body: [
            [
              {
                columns: [
                  {
                    width: "100%",
                    text: `Naziv usluge`,
                    style: "textLeft",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {
                    width: "100%",
                    text: `Početak`,
                    style: "textLeft",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {
                    width: "100%",
                    text: `Završetak`,
                    style: "textLeft",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {
                    text: `Korisnici`,
                    style: "textLeft",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {
                    text: `Cena`,
                    style: "textRight",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {
                    text: `Popust`,
                    style: "textRight",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {
                    text: `Iznos`,
                    style: "textRight",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
            ],
          ],
        },
      },
      {
        canvas: [
          {
            lineColor: "gray",
            type: "line",
            x1: 0,
            y1: 0,
            x2: 515,
            y2: 0,
            lineWidth: 1,
          },
        ],
        margin: [0, 5, 0, 10],
      },
      data.reportData?.itemsBillRegistration?.map((item: any) => {
        let country = data.reportData.country;
        let participants: string = "";
        item?.registrations?.map((oneParticipant: any) => {
          participants +=
            oneParticipant?.firstName + " " + oneParticipant?.lastName + ", ";
        });
        if (participants.charAt(participants.length - 2) === ",")
          participants = participants.slice(0, -2);
        return [
          {
            width: "50%",
            layout: "noBorders",
            table: {
              widths: ["20%", "13%", "13%", "20%", "13%", "8%", "13%"],
              body: [
                [
                  {
                    columns: [
                      {
                        width: "100%",
                        text: `${
                          item.title
                            ? item.title
                            : `Učešće na događaju ${item.eventName}`
                        } `,
                        style: "textLeft",
                        bold: false,
                        margin: [0, 0, 5, 0],
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        width: "100%",
                        text: `${formatDate(new Date(item.dateFrom))}`,
                        style: "textLeft",
                        bold: false,
                        margin: [0, 0, 0, 0],
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        width: "100%",
                        text: `${formatDate(new Date(item.dateTo))}`,
                        style: "textLeft",
                        bold: false,
                        margin: [0, 0, 0, 0],
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `${participants}`,
                        style: "textLeft",
                        bold: false,
                        margin: [0, 0, 5, 0],
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `${
                          country === "Inostranstvo"
                            ? item?.price
                            : addThousandSeparator(parseInt(item?.price ?? ""))
                        }  ${country === "Inostranstvo" ? "Eur." : "Din."}`,
                        style: "textRight",
                        bold: false,
                        margin: [0, 0, 0, 0],
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `0,00%`,
                        style: "textRight",
                        bold: false,
                        margin: [0, 0, 0, 0],
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `${
                          country === "Inostranstvo"
                            ? item?.price
                            : addThousandSeparator(parseInt(item?.price ?? ""))
                        } ${country === "Inostranstvo" ? "Eur." : "Din."}`,
                        style: "textRight",
                        bold: false,
                        margin: [0, 0, 0, 0],
                      },
                    ],
                  },
                ],
              ],
            },
          },
          {
            canvas: [
              {
                lineColor: "lightgray",
                type: "line",
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 1,
              },
            ],
            margin: [0, 0, 0, 0],
          },
        ];
      }),
      {
        canvas: [
          {
            lineColor: "gray",
            type: "line",
            x1: 0,
            y1: 0,
            x2: 515,
            y2: 0,
            lineWidth: 1,
          },
        ],
        margin: [0, 0, 0, 10],
      },
      {
        width: "50%",
        layout: "noBorders",
        table: {
          widths: ["50%", "50%"],
          body: [
            [
              {
                text: ``,
                style: "textLeft",
              },
              {
                text: `Ukupan iznos:  ${
                  data.reportData.country === "Inostranstvo"
                    ? data.reportData?.accommodationPrice
                    : addThousandSeparator(
                        parseInt(data.reportData?.accommodationPrice ?? "")
                      )
                } ${
                  data.reportData.country == "Inostranstvo" ? "Eur." : "Din."
                } `,
                style: "textRight",
                bold: true,
              },
            ],
          ],
        },
      },
      {
        width: "100%",
        layout: "noBorders",
        margin: [0, 20, 0, 10],
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `Napomena: PDV se ne iskazuje shodno čl. 35 zakona o PDV-u.`,
                style: "textLeft",
              },
            ],
          ],
        },
      },
      {
        width: "100%",
        layout: "noBorders",
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${
                  data.reportData.country == "Inostranstvo"
                    ? `U prilogu se nalaze instukcije za plaćanje pofakture.`
                    : `Uplatu izvršiti na sledeći broj žiro računa: 205-112964-17 NLB Komercijalna banka`
                }`,
                style: "textLeft",
              },
            ],
          ],
        },
      },
      {
        width: "100%",
        layout: "noBorders",
        margin: [0, 10, 0, 0],
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${
                  data.reportData.country == "Inostranstvo"
                    ? `Napomena: u navedenu cenu uključeni su i troškovi bankarskih transfera u iznosu od 35,00 evra/4.130 din po profakturi.`
                    : ``
                }`,
                style: "textLeft",
              },
            ],
          ],
        },
      },
    ],
    styles: {
      title: {
        fontSize: "18",
        alignment: "center",
        margin: [0, 20, 0, 20],
        bold: true,
      },
      textLeft: {
        fontSize: "10",
        alignment: "left",
      },
      textRight: {
        fontSize: "10",
        alignment: "right",
      },
    },
  };
};
